import React from 'react';
import { Button, ButtonProps } from '@fiverr-private/button';
import { UserAwareSourcingDomainSelectionDrawer } from '@fiverr-private/expert_sourcing_domain_selection_drawer';
import { usePricingData } from '@fiverr-private/price_upfront_components';
import { CurrencyType, DEFAULT_CURRENCY } from '../utils';
import { useDomainExpertSourcingPrice } from './useDomainExpertSourcingPrice';

type colorScheme = ButtonProps['colorScheme'];
export interface DomainExpertsSourcingDrawerButtonProps {
    buttonText: string;
    source: string;
    currencyObject?: CurrencyType;
    colorScheme: colorScheme;
}

const DomainExpertsSourcingDrawerButton = ({
    buttonText,
    source,
    currencyObject,
    colorScheme,
}: DomainExpertsSourcingDrawerButtonProps) => {
    const currencyOrDefault = currencyObject || DEFAULT_CURRENCY;
    const { sourcingDiscounPriceInCents } = useDomainExpertSourcingPrice();
    const { isPriceUpfrontEnabled, priceUpfrontConfiguration, priceUpfrontContext } = usePricingData();

    return (
        <UserAwareSourcingDomainSelectionDrawer
            priceCents={sourcingDiscounPriceInCents}
            currency={currencyOrDefault}
            source={source}
            isPriceUpfrontEnabled={isPriceUpfrontEnabled}
            priceUpfrontConfiguration={priceUpfrontConfiguration}
            priceUpfrontContext={priceUpfrontContext}
        >
            <Button colorScheme={colorScheme}>{buttonText}</Button>
        </UserAwareSourcingDomainSelectionDrawer>
    );
};

export default DomainExpertsSourcingDrawerButton;
